import type { ComposerChannel } from '~publish/components/Composer/store/hooks/useChannels'
import type { ComposerProfile } from '~publish/legacy/composer/composer/stores/types'

/**
 * Minimal interface for channel selection logic
 * This interface contains only the fields required by the selection helpers,
 * allowing us to gradually migrate from ComposerProfile to ComposerChannel
 */
export interface SelectableChannel {
  id: string
  serviceName: string
  serviceType: string
  isDisabled: boolean
}

/**
 * Convert ComposerChannel to SelectableChannel for validation helpers
 */
export const toSelectableChannel = (
  channel: ComposerChannel,
): SelectableChannel => ({
  id: channel.id,
  serviceName: channel.service,
  serviceType: channel.type,
  isDisabled: channel.isLocked || channel.isDisconnected,
})

/**
 * Convert ComposerProfile to SelectableChannel (for gradual migration)
 */
export const profileToSelectableChannel = (
  profile: ComposerProfile,
): SelectableChannel => ({
  id: profile.id,
  serviceName: profile.serviceName,
  serviceType: profile.serviceType,
  isDisabled: profile.isDisabled,
})
